// extracted by mini-css-extract-plugin
export default {"priceBlock":"hotelCardPriceBlock-module__priceBlock__k37wI"};